// extracted by mini-css-extract-plugin
export default {"dot":"Qqfg8YtE","badgeNew":"LyZ_Wx5a Qqfg8YtE","upgrade":"DbRGRS1h Qqfg8YtE"};